module.exports = __webpack_public_path__ + "images/hema_smalld655ffedcce65916ece38d4e069fb4c7.png";